import { useSelector } from 'react-redux';

import BrandLockup from 'ui-component/BrandLockup';

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
  const siteInfo = useSelector((state) => state.siteInfo);
  const systemName = siteInfo.system_name || '智旅云';

  if (siteInfo.logo) {
    return <img src={siteInfo.logo} alt={systemName} height="50" />;
  }

  return <BrandLockup compact />;
};

export default Logo;
